<div class="auth-form-fields" [ngClass]="{'auth-form-fields--double-column': layout === 'double'}">
    

    <div class="auth-form-fields__grid">
        <!-- Display Name Field (only for new authenticators) -->
        <div *ngIf="showDisplayName" class="auth-form-fields__display-name">
            <label class="auth-type__options-element-title bz-form-label">
                {{ 'AUTHENTICATION.DISPLAY_NAME' | translate }}
            </label>
            <bzg-input required [placeholder]="('AUTHENTICATION.TYPE_A_NAME' | translate) + '...'"
                [(ngModel)]="authenticator.displayName">
            </bzg-input>
        </div>
        <!-- Type Selection -->
        <div class="auth-type__options-element">
            <label class="auth-type__options-element-title bz-form-label">
                {{ "AUTHENTICATION.SUBTITLE_TYPE" | translate}}
            </label>
            <bzg-select [placeholder]="placeholder || ('AUTHENTICATION.SELECT_A_TYPE' | translate)"
                [value]="authenticator?.type" [disabled]="disabled" (valueChange)="onTypeChange($event)">
                <bzg-option *ngFor="let typeSelected of getFilteredMetadata() | keyvalue" [value]="typeSelected.key">
                    {{ 'AUTHENTICATION.TYPE_' + typeSelected.key | translate }}
                </bzg-option>
            </bzg-select>
        </div>

        <!-- Subtype Selection -->
        <div class="auth-type__options-element" *ngIf="type !== 'Multiple' && subtypes && subtypes.length > 0">
            <label class="auth-type__options-element-title bz-form-label">{{ "AUTHENTICATION.SUBTYPE" | translate }}</label>
            <bzg-select [value]="subType" [disabled]="disabled"
                [placeholder]="placeholder || ('AUTHENTICATION.SELECT_SUBTYPE' | translate)"
                (valueChange)="onSubtypeChange($event)">
                <ng-container *ngFor="let subtypeSelected of subtypes">
                    <bzg-option *ngIf="enableNewTabAuthentication && subtypeSelected !== 'WSFederated'" [value]="subtypeSelected">
                        {{ 'AUTHENTICATION.SUBTYPE_' + subtypeSelected | translate }}
                    </bzg-option>
                </ng-container>
            </bzg-select>
        </div>

        <!-- Flow Selection -->
        <div class="auth-type__options-element" *ngIf="type !== 'Multiple' &&flows && flows.length > 0">
            <label class="auth-type__options-element-title bz-form-label">
                {{ "AUTHENTICATION.ACTIVE_FLOW" | translate}}
            </label>
            <bzg-select [value]="activeFlow" [disabled]="disabled"
                [placeholder]="placeholder || ('AUTHENTICATION.SELECT_ACTIVE_FLOW' | translate)"
                (valueChange)="onFlowChange($event)">
                <bzg-option *ngFor="let flow of flows" [value]="flow">
                    {{ 'AUTHENTICATION.OPTIONS_' + flow | translate }}
                </bzg-option>
            </bzg-select>
        </div>
    </div>
</div>